module.exports = __webpack_public_path__ + "img/icon5.774c0f43.svg";